import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { PrevisaoOrcamentrariaParametros } from "../typings";

export default function usePrevisaoOrcamentariaParametro(
  enabled: boolean = true
) {
  return useQuery<PrevisaoOrcamentrariaParametros, AxiosError>(
    `/v1/previsao-orcamentaria/parametros`,
    async () => {
      const { data } = await http.get<PrevisaoOrcamentrariaParametros>(
        `/v1/previsao-orcamentaria/parametros`
      );

      return data;
    },
    {
      enabled,
    }
  );
}
